import { UPDATES } from '@/mocks/kanliao';

const KIND_STYLE: Record<string, string> = {
  新增: 'bg-primary-100 text-primary-800',
  修复: 'bg-accent-100 text-accent-800',
  更新: 'bg-secondary-100 text-secondary-800',
};

export default function Updates() {
  return (
    <section id="updates" className="w-full bg-background-100 py-12 md:py-16">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[minmax(0,1fr)_minmax(0,1.5fr)] lg:gap-12">
          {/* left intro */}
          <div className="flex flex-col">
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-100 text-primary-700">
                <i className="ri-history-line text-xl" />
              </span>
              <h2 className="font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-3xl">
                最新收录
              </h2>
            </div>
            <p className="mt-4 text-sm leading-6 text-foreground-600">
              新地址持续在收，失效入口也在不停补。翻翻更新记录，就能知道最近哪里有了新变化。
            </p>

            <div className="mt-6 rounded-xl border border-accent-200 bg-accent-50 p-4">
              <div className="flex items-start gap-3">
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                  <i className="ri-megaphone-line text-base" />
                </span>
                <div>
                  <p className="text-sm font-semibold text-accent-900">入口打不开？别急</p>
                  <p className="mt-1 text-xs leading-5 text-accent-800/90">
                    遇到失效入口记得来「看料」看一眼更新记录，我们会及时补链并收录新地址，放心用。
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* timeline list */}
          <div className="flex flex-col divide-y divide-background-200 rounded-xl border border-background-200 bg-background-50 px-5 md:px-6">
            {UPDATES.map((u) => (
              <div key={u.text} className="flex items-center gap-3 py-4 md:gap-4">
                <span className={`inline-flex shrink-0 items-center rounded-md px-2 py-1 text-xs font-semibold ${KIND_STYLE[u.kind]}`}>
                  {u.kind}
                </span>
                <div className="min-w-0 flex-1">
                  <p className="truncate text-sm text-foreground-900">{u.text}</p>
                  <p className="mt-0.5 text-xs text-foreground-400">{u.scope}</p>
                </div>
                <span className="shrink-0 text-xs text-foreground-400">{u.date}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}